import React from 'react';
import { cn } from '../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from './Card';

/**
 * Metronic InfoCard - For displaying information sections
 * Perfect for profile data, settings, account info, etc.
 *
 * @param {string} title - Card title
 * @param {React.ReactNode} children - Card content
 * @param {React.ReactNode} actions - Optional header actions
 * @param {string} className - Additional classes
 */
const InfoCard = ({
  title,
  children,
  actions,
  className
}) => {
  return (
    <Card className={cn("h-full", className)}>
      {title && (
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )}
        </CardHeader>
      )}
      <CardContent className={cn(
        "space-y-4",
        !title && "pt-6" // Add top padding if no header
      )}>
        {children}
      </CardContent>
    </Card>
  );
};

/**
 * InfoItem - Individual info row inside InfoCard
 */
export const InfoItem = ({ label, value, icon: Icon }) => (
  <div className="flex items-start justify-between">
    <div className="flex-1">
      <label className="block text-sm font-medium text-muted-foreground mb-1">
        {label}
      </label>
      <p className="text-sm text-foreground font-medium">
        {value || 'Not set'}
      </p>
    </div>
    {Icon && (
      <div className="ml-3 flex-shrink-0">
        <Icon className="h-5 w-5 text-muted-foreground" />
      </div>
    )}
  </div>
);

export default InfoCard;

